<template>
    <div
        v-loading="loading"
        class="max-w-[700px] mx-auto">
        <hts-card>
            <div>
                <label>
                    Sử dụng thông tin tuyến để tính báo giá và kế hoạch đơn hàng:
                </label>

                <hts-form-radio
                    v-model="settingData.optionRoute"
                    type="list"
                    :items="optionRoutes"
                    value-key="value"
                    label-key="label" />
            </div>

            <div class="flex justify-between items-center">
                <hts-form-button
                    class="mt-4"
                    icon-name="hi-clipboard-document-check-icon"
                    icon-position="right"
                    color="primary"
                    :loading="updating"
                    @click="updateSettings">
                    {{ $t('labels.save') }}
                </hts-form-button>
            </div>
        </hts-card>
    </div>
</template>
<script lang="ts" setup>
const { $disableReactive } = useNuxtApp()

/** Define & variables */
const loading = ref(false)
const updating = ref(false)

const props = defineProps({
  globalSettingsInformation: {
    type: Object,
    default: () => {}
  }
})
const emits = defineEmits(['updateData'])
const store = $store()

const { globalSettingsInformation } = toRefs(props)

const settingData = ref({
  optionRoute: ''
})

const optionRoutes = [
  { value: 'REQUIRED_SYSTEM', label: 'Bắt buộc sử dụng thông tin tuyến từ hệ thống.' },
  { value: 'OPTIONAL_GOOGLE_MAPS', label: 'Có thể sử dụng thông tin tuyến từ Google Maps nếu hệ thống chưa có thông tin.' }
]

/** Methods */
const getSettings = () => {
  if (globalSettingsInformation.value.route) {
    settingData.value = $disableReactive(globalSettingsInformation.value.route)
  }
}

const updateSettings = () => {
  const api = $urlClient.settings.updateRouteSettings
  updating.value = true
  $api(api, { body: { route: settingData.value } })
    .then((data) => {
      if (!data) {
        return true
      }
      const responseData: any = data.data.value
      if (responseData.success) {
        store.globalSettings.setGlobalSettings(responseData.data)
        emits('updateData')
        process.client && $toast().success($t('notifications.updateSuccess'))
      }
      updating.value = false
    })
    .catch(() => {
      process.client && $toast().error($t('notifications.updateError'))
      updating.value = false
    })
}

/** Utils */
const show = () => {
  getSettings()
}
onMounted(() => {
  show()
})
</script>
